/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { graphql } from "gatsby"
import { Fragment } from "react"
import { LocationProvider } from "frontend/src/utils/useLocation"
import { allSectionComponents } from "frontend/src/sections/components"
import { SEO } from "frontend/src/components/SEO"
import { PageContextProvider } from "frontend/src/utils/PageContext"
import { useCartURLParams } from "frontend/src/utils/useCartURLParams"
import "frontend/src/assets/styles/normalize.css"
import "frontend/src/assets/styles/font-face.css"

function RawBlocks({ rawBlocks }) {
  return (
    <Fragment>
      {rawBlocks.map((element, i) => {
        if (element._type === "reusable") {
          return <RawBlocks rawBlocks={element.blocks} key={i} />
        } else {
          const Component = allSectionComponents[element._type]
          if (Component) {
            return <Component {...element} key={i} />
          } else {
            console.log(`tried to render unknown section ${element._type}`)
            return null
          }
        }
      })}
    </Fragment>
  )
}

function PageTemplate({
  data: {
    sanityPage: { _rawBlocks, seo, tracking },
  },
  location,
}) {
  useCartURLParams(location.search)

  return (
    <LocationProvider location={location}>
      <PageContextProvider value={{ seo, tracking }}>
        <div sx={{ variant: "container.root" }}>
          <SEO seo={seo} />
          <RawBlocks rawBlocks={_rawBlocks} />
        </div>
      </PageContextProvider>
    </LocationProvider>
  )
}

export default PageTemplate

export const pageQuery = graphql`
  query GET_PAGE($slug: String) {
    sanityPage(slug: { current: { eq: $slug } }) {
      _rawBlocks(resolveReferences: { maxDepth: 13 })
      ...PageSEO
    }
  }

  fragment SocialImage on SanityImage {
    asset {
      url
      facebook: fixed(width: 1200, height: 630) {
        src
      }
      twitter: fixed(width: 280, height: 150) {
        src
      }
    }
  }

  fragment PageSEO on SanityPage {
    seo {
      description
      title
      ogImage {
        ...SocialImage
      }
    }
    tracking {
      campaignID
      optimizeID
      experimentID
      variantID
    }
  }
`
